type DiscountSectionProps = {
  title: string;
  children: React.ReactNode;
};

const DiscountSection: React.FC<DiscountSectionProps> = ({title, children}) => {
  return (
    <section className="flex w-full flex-col gap-2.5 px-4 pb-4">
      <h2 className="my-4 text-subtitle-md text-neutral-fg">{title}</h2>
      {children}
    </section>
  );
};

export default DiscountSection;
